import React, { useState, useEffect } from "react";
  import Menu from "./Menu/Menu";
  import 'bootstrap/dist/css/bootstrap.min.css';
  import Cookies from "js-cookie";
  import { Route, Routes } from "react-router-dom";
  import './App.css';
  import Home from "./Home/Home";
  import Footer from "./Footer/Footer";
  import Error from "./Error";
  import ContactUs from "./OtherPages/ContactUs";
  import Category from "./Category/Category";
  import Article from "./Article/Article";
  

  import YoutubeVIdeosCategory from "./Category/YoutubeVIdeosCategory";
  import AmpStoriesCard from "./AmpStories/AmpStoriesCard";
  import { HelmetProvider } from "react-helmet-async";
  import OtherPages from "./OtherPages/OtherPages";
  import VerticalAd from "./Ads/VerticalAd";
  import NotificationForm from './NotificationForm'

function App() {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState({
        companydata: null,     // Changed to null initially
        navdata: [],
        otherpages: {}
    });

    if (!Cookies.get('lg')) {
        Cookies.set('lg', 'en');
    }

    const fetchData = async () => {
        try {
            const lang = Cookies.get("lg") || "en";

            const response = await fetch(
                `/api/${lang}/homepage`,
                { method: "POST" }
            );

            if (!response.ok) throw new Error(`HTTP ${response.status}`);

            const finaldata = await response.json();
            console.log("APP API Response:", finaldata);

            setData(finaldata?.data || {});
        } catch (err) {
            console.error("App API Error:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="d-flex align-items-center justify-content-center vh-100">
                <p>Loading...</p>
            </div>
        );
    }

    const { companydata, navdata, otherpages } = data;

    return (
        
        <HelmetProvider>
            <Menu 
                navbardata={navdata || []} 
                companydetails={companydata || {}}   // Safe empty object
            />

                <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tl" element={<Home />} />
            <Route path="/hi" element={<Home />} />

        <Route path="/search/:searchdata" element={<Category />} />

        {/* ✅ ALL categories handled here */}
        <Route path="/:categoryname" element={<Category />} />

        <Route path="/:categoryname/:articlename" element={<Article />} />

        <Route path="/photo-stories/:storiename" element={<AmpStoriesCard />} />
        <Route path="/horoscope/:storiename" element={<AmpStoriesCard />} />
<Route path="/story/:id/:slug" element={<AmpStoriesCard />} />
        <Route path="/contact-us" element={<ContactUs />} />

        <Route path="*" element={<Error />} />
        </Routes>

            <Footer companydetails={companydata || {}} />
        </HelmetProvider>
    );
}

export default App;